
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "SelectableAccordionItem2923217919",
      {"classes":{"root":"SelectableAccordionItem2923217919__root","item":"SelectableAccordionItem2923217919__item","selector":"SelectableAccordionItem2923217919__selector","header":"SelectableAccordionItem2923217919__header","divider":"SelectableAccordionItem2923217919__divider","selectorToggle":"SelectableAccordionItem2923217919__selectorToggle","content":"SelectableAccordionItem2923217919__content","text":"SelectableAccordionItem2923217919__text","inner":"SelectableAccordionItem2923217919__inner"},"vars":{},"stVars":{"tinyVerticalPadding":"12px","smallVerticalPadding":"15px","newMediumVerticalPadding":"18px","mediumVerticalPadding":"24px"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  